import React from "react";

import { Skeleton } from "@common/skeleton";
import { Props } from "./types";
import styles from "./styles.scss";

function Milestones(_: Props) {
  return (
    <div className={styles.milestones}>
      <div className={styles.timeline}>
        <div className={styles.list} />
      </div>
      <div className={styles.dates}>
        <Skeleton className={styles.date} />
        <Skeleton className={styles.date} />
      </div>
    </div>
  );
}

export { Milestones };
